<template>
	<div>
		<DashboardHeaderVue :title="$route.name" />
		<div class="container-fluid mt--6">
			<b-overlay :show="isLoading" rounded="sm">
				<Card no-body>
					<b-row align-v="center" slot="header">
						<b-col cols="8">
							<h3 class="mb-0">Base Settings</h3>
						</b-col>
						<b-col cols="4" class="text-right">
							
						</b-col>
					</b-row>
					<b-tabs
						active-nav-item-class="bg-white font-weight-bold description"
						nav-class="bg-white description"
						card
						no-body
					>
						<b-tab title="Base Information" active>
							<Card>
								<BaseInput
									label="Name"
									:disabled="true"
									v-model="organization.appName"
								/>
								<BaseInput
									label="Address"
									:disabled="true"
									v-model="organization.appAddress"
								/>
							</Card>
							<Card>
								<b-row align-v="center" slot="header">
									<b-col cols="8">
										<h3 class="mb-0">Categories</h3>
									</b-col>
									<b-col cols="4" class="text-right">
										
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										<BaseInput
											label="Event Categories"
											id="categories"
											type="multiselect"
											internalSearch="false"
											@tag="onNewEventTag"
											@remove="onTagEventRemoved"
											:allowMultiple="true"
											:multiSelectOptions="eventCategories"
											:multiSelectValue="eventCategories"
											:multiSelectTaggable="true"
										/>
									</b-col>
								</b-row>
							</Card>
						</b-tab>
					</b-tabs>
				</Card>
			</b-overlay>
			<QuestionModal
				:show="showQuestionModal"
				:question="modalQuestion"
				@close="showQuestionModal = false"
				@yesClicked="deleteCategory"
				@noClicked="selectedCategory = null"
			/>
		</div>
	</div>
</template>
<script>
import BaseButton from '../../../components/BaseButton.vue';
import Card from '../../../components/Cards/Card.vue';
import BaseInput from '../../../components/Inputs/BaseInput.vue';
import DashboardHeaderVue from '../HeaderFooterComponents/DashboardHeader.vue';
import QuestionModal from '../../../components/Modals/QuestionModal.vue';
import { mapGetters, mapActions } from 'vuex';
import { getOrganizationFirestore } from '../../../resources/organizationFirebase';
import { collection, deleteDoc, doc, getDocs, setDoc } from 'firebase/firestore';
import CategoryItemManager from '../../../models/CategoryItemManager';

export default {
	name: 'settings',
	computed: {
		...mapGetters({
			organization: 'getOrganization',
		}),
	},
	components: {
		DashboardHeaderVue,
		Card,
		BaseInput,
		BaseButton,
		QuestionModal
	},
	data() {
		return {
			isLoading: false,
			showQuestionModal: false,
			modalQuestion: null,
			colorMounted: false,
			buttonItems: [],
			eventCategories: [],
			categoryOptions: [],
			selectedCategory: null,
			needsUpdate: false,
			updatedAppInformation: null,
			updatedPublicInformation: null,
			updatedPaymentInformation: null,
			accountInformation: null,
		};
	},
	methods: {
		...mapActions(['showNotification']),
		onNewEventTag(categoryName) {
			this.isLoading = true;
			const firestore = getOrganizationFirestore(this.organization);
			const ref = doc(collection(firestore, 'categories'));

			const categoryData = {
				categoryName: categoryName,
				categoryId: ref.id,
				isSchedule: true
			}

			setDoc(ref, categoryData).then(() => {
				console.log(`Successful uploaded: ${categoryName}`);
				this.getCategoryItems()
			})
			.catch((error) => {
				console.log(`Error uploaded: ${categoryName} with this : ${error.message}`);
			});
		},
		onTagEventRemoved(categoryData) {
			this.selectedCategory = categoryData;
			this.modalQuestion = 'Are you sure you want to delete this category?';
			this.showQuestionModal = true;
		},
		deleteCategory() {
		this.isLoading = true;
		const firestore = getOrganizationFirestore(this.organization);
		const ref = doc(firestore, `categories/${this.selectedCategory.categoryId}`);
		deleteDoc(ref)
				.then(() => {
					this.isLoading = false;
					this.showNotification({
						type: 'success',
						message: `${this.selectedCategory.categoryName} has been deleted.`,
					});
				})
				.catch((error) => {
					this.showNotification({
						type: 'danger',
						message: `${error.message}`,
					});
				});
		},
	},
	mounted() {
		this.isLoading = true;
			this.eventCategories = [];
			this.categoryOptions = [];
		CategoryItemManager.getAllCategories(this.organization).then(() => {
			this.isLoading = false
			this.categoryOptions =  CategoryItemManager.allCategories
			this.eventCategories = CategoryItemManager.allCategories.filter((category) => category.isSchedule == true);

		})
	},
};
</script>
